<header>
  <app-browse-header *ngIf="!gameStateService.getGame().running"></app-browse-header>
  <app-game-header
    *ngIf="gameStateService.getGame().running"
    [player]="gameStateService.getCurrentPlayer()"
    [players]="gameStateService.getGame().players"
    [spectators]="gameStateService.getGame().spectators"
  ></app-game-header>
</header>
